import { useState, useEffect } from "react";

/**
 * Custom hook for persistent state with localStorage
 * @param {string} key - The key to store/retrieve data in localStorage.
 * @param {any} defaultValue - The default value if no data is in localStorage.
 * @param {Function} [onChange] - Optional callback function triggered when the state changes.
 * @returns {[any, Function]} - Returns the state and a function to update it.
 */
const useDataPersistent = (key, defaultValue, onChange) => {
    const [state, setState] = useState(() => {
        const storedValue = localStorage.getItem(key);
        return storedValue ? JSON.parse(storedValue) : defaultValue;
    });

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(state));
        if (onChange) {
            onChange(state); // Trigger callback when state changes
        }
    }, [key, state, onChange]);

    // In useDataPersistent.js, consider removing this:
    useEffect(() => {
        const handleTabClose = () => {
            localStorage.removeItem(key);
        };
        window.addEventListener("beforeunload", handleTabClose);
        return () => {
            window.removeEventListener("beforeunload", handleTabClose);
        };
    }, [key]);

    return [state, setState];
};

export default useDataPersistent;
